import React from "react"
import Education from '../../pages/Education';
import Experience from '../../pages/Experience';
import Home from '../../pages/Home';
import Skills from "../../pages/Skills"
import HomeIcon from '@mui/icons-material/Home';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import Certifications from "../../pages/Certifications";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import Projects from "../../pages/Projects";
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import PsychologyIcon from '@mui/icons-material/Psychology';
import { InfoColor } from "../constants/colors";
export const routes = [
    // home
    {
        path: "/", 
        title:"Home",
        element:<Home/>,
        icon: <HomeIcon htmlColor={InfoColor.main}/>
    },
    
    // profesional
    {
        path: "/skills", 
        title:"Skills",
        element:<Skills/>,
        icon: <PsychologyIcon/>
    },
    {
        path: "/experience", 
        title:"Experience",
        element:<Experience/>,
        icon: <WorkIcon/>
    },
    {
        path: "/projects", 
        title:"Projects",
        element:<Projects/>,
        icon: <LightbulbIcon/>
    },
    {
        path: "/certifications", 
        title:"Certifications",
        element:<Certifications/>,
        icon: <WorkspacePremiumIcon/>
    },
    {
        path: "/education", 
        title:"Education",
        element:<Education/>,
        icon: <SchoolIcon/>
    },

    //casual
]

export const home = routes.slice(0, 1)
export const carrers = routes.slice(1, routes.length)